import setValue from '../../shared/actions/setValue'
import {getData, saveData} from '../../shared/actions/cacheData'
import {
    DESTINATIONS_PAGE_VIEW,
} from 'js/components/shared/constants'
import openPopup from '../../PopupConstructor/actions/popupActions'
import {GLOBAL_ERROR_POPUP} from '../../PopupConstructor/constants'
import toggleGlobalLoader from '../../Loader/actions/loaderActions'
import dataLayerPush from 'js/helpers/dataLayerPush'
import fetchHotelsList from 'js/apiCalls/hotelsList'
import {urlParamToObject} from 'js/helpers/urlHelpers'
import { tid } from '../../shared/drupalSettings'
import {LOADER_FETCH_SEARCH_RESULTS} from 'js/components/Loader/constants';

const pageView = window?.drupalSettings?.pageView ?? null
const isDestinationPage = pageView === DESTINATIONS_PAGE_VIEW

const appendTid = (URLParams) => {
    if (tid && URLParams) {
        URLParams.delete('tid')
        URLParams.append('tid', tid)
    }
    return URLParams
}

const fetchSearchResults = (dispatch, query, cacheOnly = false) => {
    return new Promise(async function (resolve, reject) {
        if (!cacheOnly) {
            dispatch(toggleGlobalLoader(true, LOADER_FETCH_SEARCH_RESULTS));
        }
        const params = new URLSearchParams(query || window.location.search)
        let paramsString = Array.from(params.entries()).length > 0 ? `?${params.toString()}` : ''
        if (isDestinationPage) {
            paramsString =  Array.from(params.entries()).length > 0 ? `?${appendTid(params).toString()}` : ''
        }

        // Main request part
        try {
            const paramsData = urlParamToObject(paramsString)
            const requestCacheKey = JSON.stringify(paramsData)
            let data = dispatch(getData(requestCacheKey))
            if (!data) {
              const results = await fetchHotelsList(paramsString)
              data = results?.data;
              data.results = data?.results?.map(el => ({
                ...el,
                isConnected: results.data.isConnected,
              })) || []
              data.brand_statement = data?.brand_statement || []
              // move not available items to the bottom of list
              const available = data.results.filter(r => r.available === true)
              const notAvailable = data.results.filter(r => r.available === false)
              data.results = available.concat(notAvailable)
              // Save results to cache
              dispatch(saveData(requestCacheKey, data))
            }

            // Set new values
            if (!cacheOnly) {
                if (data.redirect) {
                    window.location = data.redirect
                }

                dataLayerPush(data.dataLayer)
                const { dataLayer, ...dataWithoutDL } = data
                dispatch(setValue(false, dataWithoutDL))
                dispatch(toggleGlobalLoader(false, LOADER_FETCH_SEARCH_RESULTS))
            }
            resolve(data)
        } catch (e) {
            const data = e?.response?.data ?? {}
            dispatch(toggleGlobalLoader(false, LOADER_FETCH_SEARCH_RESULTS))
            if (data.message) {
                dispatch(openPopup(GLOBAL_ERROR_POPUP, data))
            }
            reject(e)
        }
    })
}

export default (query, cacheOnly) => (dispatch) => fetchSearchResults(dispatch, query, cacheOnly)
